import { AdaaHelper } from "../../../../../../../core/utils";
import { SharedFields } from "../../configs";
import { AccordionSectionConfigType, ScreenSectionConfigType } from "../../wf-difference.types";

const trackManager: ScreenSectionConfigType = {
  field: "trackManagerId",
  view: "normal",
  label: "ai_projects.tracks.track_manager",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "trackManagerName"),
};

const trackCoordinator: ScreenSectionConfigType = {
  field: "trackCoordinatorId",
  view: "normal",
  label: "ai_projects.tracks.track_coordinator",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "trackCoordinatorName"),
};

const workflowApproval: ScreenSectionConfigType = {
  field: "workflowApproval",
  view: "normal",
  label: "ai_projects.tracks.workflow_approval",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "workflowApprovalName"),
};

const weightField: ScreenSectionConfigType = {
  field: "weight",
  label: "common.tables.weight",
  view: "normal",
};

const milestoneConfig = [
  ...SharedFields.name,
  ...SharedFields.description,
  SharedFields.startDate,
  SharedFields.endDate,
  weightField,
];

const trackMilestones: AccordionSectionConfigType = {
  view: "accordion",
  field: "milestones",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "name"),
  idKey: "id",
  config: milestoneConfig,
  label: "ai_projects.milestones.title_small",
  hasDiff: ($newValue: unknown, $oldValue: unknown) => {
    const $n = $newValue as Record<string, unknown>;
    const $o = $oldValue as Record<string, unknown>;
    const keys = ["id", "nameAE", "nameEN", "dscAE", "dscEN", "startDate", "endDate", "weight"];

    return keys.some((key) => $o?.[key] !== $n?.[key]);
  },
};

export const govTrackScreenConfig = {
  type: "gov-project",
  sections: [
    ...SharedFields.name,
    ...SharedFields.description,
    SharedFields.entityIdField,
    trackManager,
    trackCoordinator,
    workflowApproval,
    trackMilestones,
  ],
};
